import { handleActions } from 'redux-actions';
import { defaultChangeEmailWidgetState } from './defaults';
import { ChangeEmailWidgetData } from './types';
import { initMyAccountPage } from '../../actions';
import { makeSpecificSaveableWidgetDataMergeFunction } from '../../widgets/utils';
import {
  setChangeEmailWidgetEmail,
  setChangeEmailWidgetPassword,
} from './actions';
import { NetworkRequestState } from '../baseTypes';

const mergeChangeEmailWidgetDataChange =
  makeSpecificSaveableWidgetDataMergeFunction(
    defaultChangeEmailWidgetState,
    widgetState => {
      return widgetState.currentData.email !== widgetState.initialData.email;
    }
  );

export default handleActions<ChangeEmailWidgetData, any>(
  {
    [initMyAccountPage.toString()]: (
      state,
      action: ReturnType<typeof initMyAccountPage>
    ) => {
      const data: ChangeEmailWidgetData['initialData'] = {
        email: action.payload.data.email ?? '',
        password: defaultChangeEmailWidgetState.initialData.password,
      };
      return {
        initialData: data,
        currentData: data,
        isDirty: false,
        canUpdateEmail: action.payload.data.canUpdateEmail,
        saveRequest: {
          status: NetworkRequestState.IDLE,
        },
      };
    },
    [setChangeEmailWidgetEmail.toString()]: (
      state,
      action: ReturnType<typeof setChangeEmailWidgetEmail>
    ) =>
      mergeChangeEmailWidgetDataChange(state, {
        email: action.payload.email,
      }),
    [setChangeEmailWidgetPassword.toString()]: (
      state,
      action: ReturnType<typeof setChangeEmailWidgetPassword>
    ) =>
      mergeChangeEmailWidgetDataChange(state, {
        password: action.payload.password,
      }),
  },
  defaultChangeEmailWidgetState
);
